import { useMemo } from "react";
import { useTernaryDarkMode } from "usehooks-ts";

import lumianText from "@/assets/lumian/lumian-text.svg";
import lumianTextWhite from "@/assets/lumian/lumian-text-white.svg";
import { useAuthStore } from "@/features/Auth";

export const useGetLogo = () => {
  const { isDarkMode } = useTernaryDarkMode();
  const userLogo = useAuthStore(state => state.whiteLabel?.logo);

  const logo = useMemo(() => {
    if (userLogo) {
      return isDarkMode
        ? userLogo.white
        : userLogo.black;
    }
    return isDarkMode
      ? lumianTextWhite
      : lumianText;
  }, [userLogo, isDarkMode]);

  return logo;
};
